module.exports = __webpack_public_path__ + "static/media/waymo.174ffbb0.jpg";